export default "__VITE_ASSET__BrxYoG79__"